export * from './src/devcenter-bi-events-v1-send-bi-event-response-bi-events.meta.js';
